module.exports = __webpack_public_path__ + "d6413ba1/img/delete-icon.eb7de062.svg";